import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../../kms.service';
import { DeleteConfirmComponent } from '../../delete-confirm/delete-confirm.component';
import { RelatedInstanceSelectComponent } from '../related-instance-select/related-instance-select.component';
import { InstanceInfoViewComponent } from '../../../instance-info-view/instance-info-view.component';
declare var $;
@Component({
  selector: 'app-related-instance-query',
  templateUrl: './related-instance-query.component.html',
  styleUrls: ['./related-instance-query.component.css']
})
export class RelatedInstanceQueryComponent implements OnInit {
    // 当前所处模块是否为关联实体
    @Input() tabId:string = '';
    // 所属标记id
    @Input() imageMarkId:string = '';
    // 所属标记名称
    @Input() markName:string = '';
    // 状态
    @Input() state:string = 'edit';
    // 表格对象
    @ViewChild("swtable") swtable: SwGridTableComponent; 
    // 搜索数据内容
    searchDatas = {
        instanceName: '',  // 实体名称
    }
    // 实体表格数据
    datas:any = [];
    // 表格是否显示加载中
    isLoading: boolean = false;
    // 表格分页组件
    pageBase: any = { orderBy: null }
    // 表格操作按钮
    toolbar = [];
    selectedDatas:any = [];
    constructor(
        private box: SwMassageBoxService,
        private router: Router,
        private create:SwCreateModalComponentService,
        private kmsService: KmsService
    ) { }

    ngOnInit() {
    }

    ngOnChanges(){
      if(this.tabId == 'relatedInstance' && this.imageMarkId){
        this.handleSelectClick();
        if(this.state == 'edit'){
          this.toolbar = [
            { status: true, functionCode: 'select', functionName: '选择实体', icon: 'glyphicon glyphicon-folder-open', children: [] },
            { status: true, functionCode: 'delete', functionName: '批量删除', icon: 'glyphicon glyphicon-remove', children: [] }
          ];
        }else{
          this.toolbar = []
        }
      }
    }

    //enter键触发搜索
    enterSearch(event) {
      if (event.keyCode == '13') {
          this.handleSelectClick();
      }
    }

    // 查询按钮方法
    handleSelectClick() {
      this.pageBase = {
        current: 1,
        size: 10
      };
      this.getData();
    }

    //获取数据
    getData() {
      this.isLoading = true;
      let params = {
        'instanceName': $.trim(this.searchDatas.instanceName),
        'imageMarkId': this.imageMarkId,
        'current': this.pageBase.current,
        'size': this.pageBase.size
      }
      this.kmsService.queryMarkRealtedInstance(params).subscribe(
        data => {
          this.isLoading = false;
          if (data.code == '200') {
            this.pageBase = data.data;
            this.datas = data.data.records;
          } else {
            this.box.waring(data.msg);
          }
        }
      );
    }

    // 表格按钮点击事件
    handleOperationClick(event) {
      switch (event) {
        case "select": this.selectFiles(); break; // 从实体库中选择
        case "delete": this.handleDeleteClick(); break;  // 批量删除
      }
    }

    /**
     * 工具栏点击事件--选择文件
     * @ignore
     */
    selectFiles(){
      let params = {
        'imageMarkId': this.imageMarkId,
        'markName': this.markName
      }
      this.create.createModal(RelatedInstanceSelectComponent,params,this.selectCallback.bind(this))
    }

    /**
     * 选择完成后的回调
     * @ignore
     */
    selectCallback(data?){
      this.handleSelectClick();
    }

    // 批量删除
    handleDeleteClick() {
      if (this.selectedDatas.length == 0) {
        this.box.danger('请至少选择一条数据！');
        return;
      }
      let ids = [];
      this.selectedDatas.forEach(item => {
        ids.push(item.instanceMarkShipId);
      });
      let params = {
        name: 'relatedInstanceDelete',
        ids: ids
      }
      this.create.createModal(DeleteConfirmComponent, params, this.handleSelectClick.bind(this));
    }

    /**
     * 点击td中的按钮
     * @ignore
     */
    clickTdBtn(type, data) {
      //禁止冒泡
      event.stopPropagation();
      // 查看
      if (type == 'view') {
        let param = { instanceId: data.instanceId };
        this.create.createModal(InstanceInfoViewComponent, param)
      }
      // 单条编辑
      else if (type == 'edit') {
        let selectData = {
          addOrUpdate: 'Edit',
          instanceId: data.instanceId,
          conceptId: data.conceptId,
          conceptName: data.conceptName,
          serialNumber: data.serialNumber,
        };
        this.router.navigate(
            ['/kms/InstanceAdd'],
            { queryParams: { Title: '编辑实体信息', selectData: JSON.stringify(selectData) } }
        );
      }
      // 单条删除
      else if (type == 'delete') {
        let params = {
          name: 'relatedInstanceDelete',
          ids: [data.instanceMarkShipId]
        }
        this.create.createModal(DeleteConfirmComponent, params, this.handleSelectClick.bind(this));
      }
    }

    // 表格选中数据
    handleSelectData(event) {
      this.selectedDatas = event;
      //设置表格按钮组状态
      this.swtable.toolbarAllEnable();
      if (this.selectedDatas.length == 0) {
          this.swtable.toolbarDisable("edit");
          this.swtable.toolbarDisable("delete");
      };
    }

    // 表格分页切换方法
    handlePageClick(event) {
      this.pageBase = event;
      this.getData();
    }

    // 重置按钮事件方法
    handleReloadClick() {
      this.searchDatas = {
          instanceName: ''
      }
      this.pageBase = {
        current: 1,
        size: 10
      };
      this.getData();
    }
}


